/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {
    IBetWayWinData,
    IBlitzKriegData,
    IBlitzKriegGameData,
} from "./IBlitzKriegData";
import {IParsedStackedSymbolName, StackedSymbol} from "../../../core/reel/stackedsymbol/StackedSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DDayGameConfig} from "../../DDayGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BlitzkriegSymbols} from "../../symbol/DDaySymbolConfig";
import {DDay} from "../../DDay";

export class BlitzKriegDataParser {

    constructor() {

    }

    public parseReels(rawData: IBlitzKriegData, isInit: boolean = false): string[][] {
        // Removing Scatter from overflow symbols.
        rawData.reels.forEach((reel: string[]) => {
            reel.forEach((symbolName: string) => {
                if (!isInit) {
                    if (reel[0] === BlitzkriegSymbols.S) {
                        reel[0] = BlitzkriegSymbols.L2;
                    }
                    if (reel[reel.length - 1] === BlitzkriegSymbols.S) {
                        reel[reel.length - 1] = BlitzkriegSymbols.L2;
                    }
                }
            });
        })
        return this.parseStackedSymbolsInReels(rawData.reels);
    }

    public parseEvaluatedReels(rawData: IBlitzKriegData): string[][] {
        return rawData.evaluatedArea;
    }

    public parseStackedSymbolsInReels(rawReels: string[][], parsedSymbolNamesUnder?: string[]): string[][] {
        let result: string[][] = [];

        rawReels.forEach((rawReel, reelId) => {
            result.push(this.parseStackedSymbolsInReel(rawReel, reelId, parsedSymbolNamesUnder == null ? undefined : parsedSymbolNamesUnder[reelId]));
        });

        return result;
    }

    // Always start to parse the reel from the bottom because in all cases the bottom of the reel is already known.
    // For special cases like the reel is up side down, please create your own parsing.
    public parseStackedSymbolsInReel(rawReel: string[], reelIndex: number, parsedSymbolNameUnder?: string): string[] {
        const input: string[] = rawReel.concat();
        const result: string[] = [];

        if (parsedSymbolNameUnder == null) {
            let bottomStackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1], reelIndex);
            // Find out if the reel has half stacked symbols in the bottom
            if (bottomStackedSymName.isStacked) {
                let i: number;
                for (i = 1; i < input.length; i++) {
                    const testStackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1 - i], reelIndex);
                    if (testStackedSymName.isStacked && testStackedSymName.symName === bottomStackedSymName.symName) {
                        bottomStackedSymName = testStackedSymName;
                    } else {
                        break;
                    }
                }
                // i is the first symbol that's not in the stack.
                i = i % bottomStackedSymName.totalNum; // If num of stacked symbols in the bottom is bigger than stacked.totalNum.
                parsedSymbolNameUnder = `${bottomStackedSymName.symName}*${i.toString()}`;
            } else {
                parsedSymbolNameUnder = "NonStackedDummySym";
            }
        }

        while (input.length > 0) {
            const stackedSymNameUnder: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(result.length > 0 ? result[0] : parsedSymbolNameUnder, reelIndex);
            const stackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input.pop()!, reelIndex);

            // For continue stacked symbol
            if (stackedSymNameUnder.isStacked && stackedSymNameUnder.index > 0) {
                if (!stackedSymName.isStacked || stackedSymName.symName !== stackedSymNameUnder.symName) {
                    debugger;
                    Logger.logDev("If you are using the outcome setter, this might be a case that the outcome made an illegal server data. Please take to the server dev to check if that worth a fix.");
                    throw new Error(`ServerDataParser.parseStackedSymbolsInReel():reelId = ${reelIndex}, reelData = ${rawReel.toString()}, symName = ${stackedSymName.symName}, the symbol should be ${stackedSymName.totalNum}-stacked!`);
                }
                result.unshift(`${stackedSymName.symName}*${(stackedSymNameUnder.index - 1).toString()}`);
                continue;
            }

            // For starting a new stacked symbol
            if (stackedSymName.isStacked) {
                result.unshift(`${stackedSymName.symName}*${(stackedSymName.totalNum - 1).toString()}`);
                continue;
            }

            // For non stacked symbol
            result.unshift(stackedSymName.symName);
        }

        return result;
    }

    public parseScatterPositions(rawData: IBlitzKriegData): number[] {
        const result = ArrayHelper.initArrayWithValues(DDayGameConfig.REELS_NUM, reelId => -1);
        for (let reelId = 0; reelId < DDayGameConfig.REELS_NUM; reelId++) {
            for (let symId = 1; symId < rawData.reels[reelId].length - 1; symId++) { // TODO: change symbol positions.
                if (rawData.reels[reelId][symId] === "S") {
                    if (result[reelId] === -1) {
                        result[reelId] = symId - 1;
                    } else {
                        debugger;
                        throw new Error(`Server gives more than 1 Scatter on reel ${reelId}!`);
                        // https://github.com/nolimitcity/tombstonerip/issues/393
                        // rawData.reels[reelId][symId] = this.findLowestNoWinSymbol(rawData.reels[0])
                    }
                }
            }
        }

        return result;
    }

    public parseBetWins(rawData: IBlitzKriegGameData): IBetWayWinData[] {
        return rawData.betWayWins!;
    }

    public parseWinRatio(winRatio: number): IWinRatioConfig | null {
        let ratioConfigs: IWinRatioConfig[] = DDayGameConfig.WIN_RATIOS;
        let ratioConfig;
        for (let i: number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if (winRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }

        if (ratioConfig) {
            return {
                index: ratioConfig.index,
                ratio: winRatio,
                name: ratioConfig.name,
                duration: ratioConfig.duration,
                bigWinLevel: ratioConfig.bigWinLevel
            }
        }
        return null;
    }

    public parseNearWinReels(scatterPositions: number[], wasFeatureBuy: boolean): boolean[] {
        const result = ArrayHelper.initArrayWithValues(DDayGameConfig.REELS_NUM, reelId => false);
        if (wasFeatureBuy && DDay.model.buyFeatureName !== "LUCKY_DRAW") {
            return result;
        }
        let scatterCount: number = 0;
        scatterPositions.forEach((isScatter: number, index: number) => {
            if (scatterCount > 1) {
                result[index] = true;
            }
            if (isScatter > -1) {
                scatterCount++;
            }
        });
        return result;
    }
}
